import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.header`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 36px;
    border-bottom: 2px solid ${theme.colors.mainBg};
    border-left: 6px solid ${theme.colors.secondary};
    border-radius: ${theme.border.radius};

    > h1 {
      color: ${theme.colors.primary};
      font-family: ${theme.font.montserrat};
      font-weight: ${theme.font.xbold};
      font-size: ${theme.font.sizes.medium};
    }

    > div {
      width: 50%;
      display: flex;
      justify-content: end;
      gap: 20px;

      button {
        max-width: 200px;
        position: relative;

        svg {
          position: absolute;
          left: 22px;
          top: 12px;
        }
      }
    }

    > button {
      max-width: 182px;
      position: relative;

      > svg {
        position: absolute;
        left: 22px;
        top: 12px;
      }
    }

    ${media.lessThan('medium')`
      h1{
        font-size: ${theme.font.sizes.xsmall};
      }

      div {
        width: 74%;
        gap: 4px;
      }

      svg {
        display: none;
      }
    `}

    ${media.lessThan('small')`
      padding: 12px 6px;

      h1{
        font-size: ${theme.font.sizes.xxsmall};
      }

      button{
        max-width: 122px;
        margin-right: -0px;

        svg {
          display: none;
        }
      }
    `}
  `}
`
